const isDigitalAsset = (product) => !!product?.is_digital_asset;

export default isDigitalAsset;
